module.exports = "/_next/static/images/step3Illustratiom-7c9a74b774a3fe0791dc7d70c9bab50a.svg";